(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mo-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const tabBtns = document.querySelectorAll(".tab-btn");
    const tabContents = document.querySelectorAll(".tab-content");

    tabBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        const val = btn.getAttribute("data-val");

        // Remove 'active' class from all buttons
        tabBtns.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");

        // Show matching tab-content by data-val
        tabContents.forEach(content => {
          if (content.getAttribute("data-val") === val || val === "all") {
            content.classList.add("active");
          } else {
            content.classList.remove("active");
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mo-review-slider"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function () {
    new Swiper('.review-swiper', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: '.review-swiper .swiper-pagination',
        clickable: true,
      },
      navigation: false,
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nws-faq"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
       $(".acc-title-btn").click(function() {
           // Close all open accordions
           $(".acc-title-btn").not(this).removeClass("nws-foo-active");
           $(".acc-tab-body").not($(this).next()).slideUp();

           // Toggle the current accordion
           $(this).toggleClass("nws-foo-active");
           $(this).next().slideToggle();
       });
   });
  
  const items = document.querySelectorAll('.accordion .item');
  items.forEach((item, index) => {
    const formattedIndex = String(index + 1).padStart(2, '0'); // Adds leading zero
    item.insertAdjacentHTML('afterbegin', `<div class="number">${formattedIndex}</div>`);
  });

  } catch(e) { console.error(e); }
})();
})();
